import React from 'react';
import PropTypes from 'prop-types';
import withStyles, { css } from '@bd/bdui-styles';
import RouteCollection from '@bd/bdcore-named-routes';
import { userLogin, userPasswordResetRequest } from '@bd/bdcore-data/build/User/actions';
import withData from '@bd/bdcore-data';

const defaultStyles = css`
.required {
  color: #FA000B;
}
`;

class ClientLogin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      emailReset: '',
      reset: false,
    };
  }

  handleInput = event => {
    const key = event.target.name;
    const value = event.target.value;

    this.setState({
      [key]: value,
    });
  }

  render() {
    const { bodyCopy, className, dispatch, userError, hidePasswordReset } = this.props;
    const { email, password, emailReset, reset } = this.state;
    const resetUrl = `${window.location.protocol}//${window.location.hostname}${[80, 443].includes(window.location.port) ? '' : `:${window.location.port}`}${RouteCollection.getPath('password-reset')}?key=token`;

    return (
      <form className={className}>
        <div className="ClientLogin">
          {
            bodyCopy &&
            <div className="ClientLogin_bodyCopy">
              {bodyCopy}
            </div>
          }
          <div className="ClientLogin_formSection styled-form">
            <h4 className="form-heading GoldText">Login</h4>
            <div className="form-group">
              <label htmlFor="email">Email <span className="required">*</span></label>
              <input className="form-control" type="text" name="email" id="email" onChange={e => this.handleInput(e)} required value={email} />
            </div>
            <div className="form-group">
              <label htmlFor="password">Password <span className="required">*</span></label>
              <input className="form-control" type="password" name="password" id="password" onChange={e => this.handleInput(e)} required value={password} />
            </div>
            {
              userError &&
              <div>Username or password was incorrect</div>
            }
            <button type="button" className="btn Btn Gold" onClick={() => dispatch(userLogin(email, password))} disabled={!email || !password}>Login</button>
          </div>
          {
            !hidePasswordReset &&
            <div className="ClientLogin_formSection styled-form">
              <h4 className="form-heading GoldText">Password Reset</h4>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input className="form-control" type="text" name="emailReset" id="emailReset" onChange={this.handleInput} required />
              </div>
              {
                !reset &&
                <button type="button" className="Btn Gold" onClick={() => { dispatch(userPasswordResetRequest(emailReset, resetUrl)); this.setState({ reset: true }); }} disabled={!emailReset}>Reset Password</button>
              }
              {
                reset &&
                <div className="ClientLogin_resetSuccess">You will receive an email shortly with your password reset link.</div>
              }
            </div>
          }
        </div>
      </form>
    );
  }
}

ClientLogin.propTypes = {
  bodyCopy: PropTypes.string,
  className: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  userError: PropTypes.string,
  hidePasswordReset: PropTypes.bool,
};

ClientLogin.defaultProps = {
  hidePasswordReset: false,
};

ClientLogin.defaultProps = {
  bodyCopy: undefined,
  className: undefined,
  userError: undefined,
};

export default withData({})(withStyles(defaultStyles)(ClientLogin));



// WEBPACK FOOTER //
// ./src/bdcoreCandidates/ClientLogin.js